import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=7c898175"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=7c898175&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c898175')) {
      api.createRecord('7c898175', component.options)
    } else {
      api.reload('7c898175', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=7c898175", function () {
      api.rerender('7c898175', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/convalescenceSystem/convalescenceInfo/detail.vue"
export default component.exports